(function(){
  'use strict';
  document.documentElement.dataset.aiStoreRc='clarity-recovery-rc9';
  var allowedProduct='/products/ai-store-business-clarity-diagnostic';
  function normalizedPath(value){
    try{return new URL(String(value||''),window.location.origin).pathname.replace(/\/+$/,'')||'/';}
    catch(error){return String(value||'').split('?')[0].split('#')[0].replace(/\/+$/,'')||'/';}
  }
  function isCommercialTarget(value){
    var path=normalizedPath(value).toLowerCase();
    if(path==='/cart'||path.indexOf('/cart/')===0||path==='/checkout'||path.indexOf('/checkouts')===0)return true;
    if(path.indexOf('/products/')===0 && path!==allowedProduct)return true;
    return false;
  }
  function recover(){
    var diagnosis=document.getElementById('ai-diagnosis');
    if(diagnosis){diagnosis.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});}
    else{window.location.assign('/#ai-diagnosis');}
  }
  document.addEventListener('submit',function(event){
    var form=event.target;
    if(form&&(isCommercialTarget(form.action)||form.querySelector('[name="checkout"],[name="add"]'))){
      event.preventDefault();event.stopImmediatePropagation();recover();
    }
  },true);
  document.addEventListener('click',function(event){
    var target=event.target.closest&&event.target.closest('a[href],button[name="checkout"],button[name="add"],input[name="checkout"],input[name="add"]');
    if(!target)return;
    var href=target.getAttribute&&target.getAttribute('href');
    if(!href || isCommercialTarget(href) || target.matches('[name="checkout"],[name="add"]')){
      if(target.matches('[name="checkout"],[name="add"]') || (href && isCommercialTarget(href))){event.preventDefault();event.stopImmediatePropagation();recover();}
    }
  },true);
})();
